// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JMOF","colMin":"styles_colMin__u4mdE"};